import axios from "axios";

async function buscarCep(cep: string) {
  const cepLimpo = cep.replace(/\D/g, "");

  const resposta = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

  if (resposta.data.erro) {
    throw new Error("CEP inválido");
  }

  return resposta.data
}

export default buscarCep;